import queryString from 'query-string'

import { get } from '../utils'
import type { EmbedListArgs } from './ConversationsApi'

/**
 * The public, unauthenticated topic feed behind /embed/topics.
 *
 * Same contract as embed/ConversationsApi -- see the note there on why
 * `partner_ids` is comma-joined rather than sent as an array.
 */
class EmbedTopicsApi {
  getAll({ limit, offset, partnerIds = [] }: EmbedListArgs) {
    const params = queryString.stringify({
      limit,
      offset,
      site_name: global.siteName,
      ...(partnerIds.length > 0 ? { partner_ids: partnerIds.join(',') } : {})
    })

    return get(`/embed/topics?${params}`)
  }
}

export default new EmbedTopicsApi()
